import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { selectIsAuthenticated } from "../redux/features/auth/authSelectors";

const PrivateRoute = () => {
  const isAuthenticated = selectIsAuthenticated;

  return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
};

export default PrivateRoute;
